import axios from 'axios';

const imageService = {
  generateImage: async (prompt, imageSize) => {
    try {
      // Call our backend API to handle credit deduction and use InstaImage service
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/images/generate`,
        { 
          prompt,
          imageSize,
          usePollinationsApi: false // Flag to indicate we want to use InstaImage service
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default imageService; 